import React from 'react'
import { useState } from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'

const CopyButton = ({ onClick, classes, cypressId }) => {
  const [copied, setCopied] = useState(false)
  const action = () => {
    onClick()
    setCopied(true)
    setTimeout(() => setCopied(false), 1400)
  }
  return (
    <div onClick={action} className={classes.container} cypress_id={cypressId}>
      {copied ? 'Copied' : 'Copy token'}
    </div>
  )
}

export default injectStyles(styles)(CopyButton)
